/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  float: 'left',
  padding: `${theme.margin.medium} ${theme.margin.small} ${theme.margin.fine}`,
  margin: `-${theme.margin.small} ${theme.margin.small} 0 -${theme.margin.small}`,
  cursor: 'pointer',
  extend: [
    {
      condition: theme.origDirection === 'rtl',
      style: {
        margin: `-${theme.margin.small} -${theme.margin.small} 0 ${theme.margin.small}`,
        '& svg': {
          rotate: '180deg',
        },
      },
    },
  ],
});

export default function BackIcon({ className, onClick }) {
  const { css } = useFela();

  return (
    <div onClick={onClick} className={`${className ? `${className} ` : ''}${css(rules)}`}>
      <svg width="11" height="20" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.21172 17.175L0.786718 9.75C0.661718 9.625 0.574219 9.5 0.524219 9.375C0.474219 9.25 0.449219 9.1125 0.449219 8.9625C0.449219 8.8125 0.474219 8.675 0.524219 8.55C0.574219 8.425 0.661718 8.3 0.786718 8.175L8.24922 0.7125C8.47422 0.4875 8.74297 0.375 9.05547 0.375C9.36797 0.375 9.63672 0.4875 9.86172 0.7125C10.0867 0.9375 10.193 1.2125 10.1805 1.5375C10.168 1.8625 10.0492 2.1375 9.82422 2.3625L3.22422 8.9625L9.86172 15.6C10.0867 15.825 10.1992 16.0875 10.1992 16.3875C10.1992 16.6875 10.0867 16.95 9.86172 17.175C9.63672 17.4 9.36172 17.5125 9.03672 17.5125C8.71172 17.5125 8.43672 17.4 8.21172 17.175Z" fill="white" />
      </svg>
    </div>
  );
}
BackIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
